







































import Debug from 'debug';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import i18n from '@/plugins/i18n';
import { TranslateResult } from 'vue-i18n';

const debug = Debug('quiz-intro-component');

@Component
export default class QuizIntroComponent extends Vue {
  @Prop({ required: true })
  public description: string;

  @Prop({ required: true })
  public hasExam: boolean

  @Prop({ required: true })
  public hasPractice: boolean

  @Prop({ required: true })
  public percentToPass: number;

  @Prop({ required: true })
  public isInContinueSession: boolean

  @Prop({ required: true })
  public continueType: '' | 'exam' | 'practice';

  private get title(): TranslateResult {
    if (this.isInContinueSession) {
      return this.continueType === 'exam'
        ? this.t('quiz.continue_exam_title')
        : this.t('quiz.continue_practice_title');
    }

    return this.t('quiz.start_quiz_title');
  }

  // private get finishCaption(): TranslateResult {
  //   if (this.isInContinueSession) {
  //     return this.t('quiz.abort')
  //   }
  //   // return this.startedMode === 'exam'
  //   //   ? this.t('quiz.finish')
  //   //   : this.t('quiz.abort');
  // }

  // private get haveStartedSession(): boolean {
  //   //return this.startedMode !== null;
  //   return false;
  // }

  private get welcomeText(): string|TranslateResult|null {
    debug('resolving welcome text', this.continueType, this.description);

    if (this.continueType !== '') {
      return null;
    }

    if (this.description) {
      return this.description
    }

    const defaultDescription: TranslateResult = this.hasExam
          ? this.t('quiz.start_exam_description')
          : this.t('quiz.start_practice_description');

    return defaultDescription
  }

  private t(key: string, params: any = {}): TranslateResult {
    return i18n.t(key, params);
  }

  @Emit('continue')
  private emitContinue(): void {

  }

  @Emit('abort')
  private emitAbort(): void {

  }

  @Emit('startExam')
  private emitStartExam(): void {

  }

  @Emit('startPractice')
  private emitStartPractice(): void {

  }
}
